import { create } from 'zustand';
import { devtools } from "zustand/middleware";
import i18n from '../tools/i18n';
import { LOCAL_STORAGE_KEYS } from '../constants/local-storage-keys';
import type { ILangStore } from '../types/zustand/lang';
import { getLang } from '../utils/localStorageUtils';
import { addToLocalStorage } from '../utils/manageLocalStorage';
import { addDjangoLangToCookies } from '../utils/addDjangoLangToCookies';

type TLang = 'en' | 'ar';

const setHtmlLangAttributes = (lang: TLang) => {
  document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
  document.documentElement.setAttribute('lang', lang);
};

const handleLangChange = (lang: TLang) => {
  addToLocalStorage(LOCAL_STORAGE_KEYS.LANGUAGE, lang);
  i18n.changeLanguage(lang);
  addDjangoLangToCookies(lang);
  setHtmlLangAttributes(lang);
};


export const useLangStore = create<ILangStore>()(
  devtools(
    (set) => ({
      lang: getLang(),
      initLang: () => {
        const lang = getLang();
        addDjangoLangToCookies(lang);
        setHtmlLangAttributes(lang);
      },
      setLang: (language) => {
        const lang = language ?? (getLang() === 'ar' ? 'en' : 'ar');
        handleLangChange(lang);
        set(() => ({ lang }), undefined, 'LanguageStore/setLang');
      },
    } as ILangStore),
    { name: 'LanguageStore' }
  )
);